import { useQuery } from "convex/react";
import { api } from "../../convex/_generated/api";

type Surface = "app" | "outlook-addin";

const BUNDLE_SHA: string | undefined = import.meta.env.VITE_GIT_SHA;

// Loud warning if a production build ships without a baked-in SHA. Without
// it the update detection silently no-ops and users never get reload prompts.
if (import.meta.env.PROD && !BUNDLE_SHA) {
	console.warn(
		"[useFrontendUpdate] VITE_GIT_SHA missing from production build — frontend update notifications disabled.",
	);
}

export function useFrontendUpdate(surface: Surface): {
	updateAvailable: boolean;
	serverSha: string | null;
	reload: () => void;
} {
	const serverSha = useQuery(
		api.deployedVersions.getDeployedSha,
		BUNDLE_SHA ? { surface } : "skip",
	);

	const resolvedServerSha = typeof serverSha === "string" ? serverSha : null;
	const updateAvailable =
		BUNDLE_SHA !== undefined &&
		resolvedServerSha !== null &&
		resolvedServerSha !== BUNDLE_SHA;

	return {
		updateAvailable,
		serverSha: resolvedServerSha,
		reload: () => window.location.reload(),
	};
}
